import React from 'react';
import PropTypes from 'prop-types';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import AddSchoolForm from './AddSchoolForm';
import SchoolCard from './SchoolCard';
import style from './IdCardPrinterBoard.module.sass';

const SchoolsColumn = ({
  droppableId, title, schools, busyIds, moveLabel, onMove, onRemoveRoster, onUnpairPrinter, onRetirePrinter,
  hoveredSchoolId, addSchoolForm, showDeliveredDate,
}) => (
  <div className={style.column}>
    <div className={style.columnHeader}>
      {title}
      <span className={style.columnCount}>{schools.length}</span>
    </div>

    {addSchoolForm && (
      <AddSchoolForm
        onAddSchool={addSchoolForm.onAddSchool}
        schoolSearchUrl={addSchoolForm.schoolSearchUrl}
        disabled={busyIds.includes('add-school')}
      />
    )}

    <Droppable droppableId={droppableId} type="school">
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className={`${style.columnBody} ${snapshot.isDraggingOver ? style.dragOver : ''}`}
        >
          {schools.length === 0 && <div className={style.emptyState}>No schools here.</div>}

          {schools.map((school, index) => (
            <Draggable key={school.school_id} draggableId={`school-${school.school_id}`} index={index}>
              {(dragProvided, dragSnapshot) => (
                <div
                  ref={dragProvided.innerRef}
                  {...dragProvided.draggableProps}
                  {...dragProvided.dragHandleProps}
                >
                  <SchoolCard
                    school={school}
                    busyIds={busyIds}
                    moveLabel={moveLabel}
                    onMove={onMove}
                    onRemoveRoster={onRemoveRoster}
                    onUnpairPrinter={onUnpairPrinter}
                    onRetirePrinter={onRetirePrinter}
                    isDragging={dragSnapshot.isDragging}
                    isHoveredForPrinterDrop={hoveredSchoolId === school.school_id}
                    showDeliveredDate={showDeliveredDate}
                  />
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </div>
);

SchoolsColumn.propTypes = {
  droppableId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  schools: PropTypes.arrayOf(PropTypes.shape({
    school_id: PropTypes.number.isRequired,
  })).isRequired,
  busyIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  moveLabel: PropTypes.string.isRequired,
  onMove: PropTypes.func.isRequired,
  onRemoveRoster: PropTypes.func,
  onUnpairPrinter: PropTypes.func.isRequired,
  onRetirePrinter: PropTypes.func.isRequired,
  hoveredSchoolId: PropTypes.number,
  addSchoolForm: PropTypes.shape({
    onAddSchool: PropTypes.func.isRequired,
    schoolSearchUrl: PropTypes.string.isRequired,
  }),
  showDeliveredDate: PropTypes.bool,
};

SchoolsColumn.defaultProps = {
  onRemoveRoster: null,
  hoveredSchoolId: null,
  addSchoolForm: null,
  showDeliveredDate: false,
};

export default SchoolsColumn;
